import { Form, Button, Row, Col, Table, Alert, Badge } from 'react-bootstrap';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setIsLoading } from '../general/actions';
import { currencyFormater, downloadExcel } from '../general/utils';
import SelectAgreement from '../general/selectAgreement';
import Print from '../order/print';
import Log from '../order/log';

const STATUS_STYLE = {
    1: { background: '#fef9c3', color: '#854d0e', border: '1px solid #fde047' },
    2: { background: '#dbeafe', color: '#1e40af', border: '1px solid #93c5fd' },
    3: { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' },
};

function StatusBadge({ status }) {
    const s = STATUS_STYLE[status?.id] || { background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' };
    return (
        <span className="report-status-badge" style={s}>
            {status?.id}: {status?.description}
        </span>
    );
}

function OrdersReport(props) {
    const { setIsLoading, roles } = props;
    const navigate = useNavigate();

    const [orders, setOrders] = useState([]);
    const [idPrint, setIdPrint] = useState(false);
    const [showPrint, setShowPrint] = useState(false);
    const [idOrderLog, setIdOrderLog] = useState(false);
    const [showLog, setShowLog] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [statuses, setStatuses] = useState([]);

    const [orderId, setOrderId] = useState('');
    const [agreementFilter, setAgreementFilter] = useState(0);
    const [department, setDepartment] = useState('');
    const [status, setStatus] = useState('');
    const [onlyMyOrders, setOnlyMyOrders] = useState(false);
    const [deliveryAtStart, setDeliveryAtStart] = useState('');
    const [deliveryAtEnd, setDeliveryAtEnd] = useState('');
    const [createdAtStart, setCreatedAtStart] = useState('');
    const [createdAtEnd, setCreatedAtEnd] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('warning');

    const clearFilters = () => {
        setOrderId('');
        setDepartment('');
        setStatus('');
        setOnlyMyOrders(false);
        setDeliveryAtStart('');
        setDeliveryAtEnd('');
        setCreatedAtStart('');
        setCreatedAtEnd('');
    };

    useEffect(() => {
        if (!statuses.length) getStatuses();
        const today = new Date();
        setDeliveryAtStart(today.toISOString().split('T')[0]);
        today.setDate(today.getDate() + 30);
        setDeliveryAtEnd(today.toISOString().split('T')[0]);
    }, []);

    useEffect(() => {
        if (agreementFilter) {
            getOrders();
            setOrderId('');
            if (!departments.length) getDepartments();
        } else {
            setOrders([]);
            setMessageType('info');
            setMessage('Selecciona un contrato para ver los pedidos');
        }
    }, [agreementFilter]);

    const getStatuses = () => {
        setIsLoading(true);
        axiosInstance.get('/order-statuses')
            .then(res => { setStatuses(res.data); setIsLoading(false); })
            .catch(err => { setIsLoading(false); console.log(err); });
    };

    const getDepartments = () => {
        setIsLoading(true);
        axiosInstance.get('/departments/agreements/' + agreementFilter)
            .then(res => { setDepartments(res.data); setIsLoading(false); })
            .catch(err => { setIsLoading(false); console.log(err); });
    };

    const getOrders = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get('/orders/filters/', {
                params: {
                    agreement_id: agreementFilter,
                    id: orderId,
                    my_orders: onlyMyOrders,
                    order_status_id: status,
                    created_start_date: createdAtStart,
                    created_end_date: createdAtEnd,
                    delivery_start_date: deliveryAtStart,
                    delivery_end_date: deliveryAtEnd,
                    department_id: department,
                },
            });
            setOrders(response.data);
            if (response.data.length) {
                setMessage('');
            } else {
                setMessageType('info');
                setMessage('No hay resultados con los filtros seleccionados');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const totalRows = orders.reduce((acc, o) => acc + o.order_detail.length, 0);

    return (
        <>
            {/* ── Ayuda ── */}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, background: 'rgba(37,99,235,0.05)', border: '1px solid rgba(37,99,235,0.15)', borderRadius: 12, padding: '12px 16px', marginBottom: 14 }}>
                <i className="fa fa-lightbulb-o" style={{ color: 'var(--abi-primary)', fontSize: 18, marginTop: 2, flexShrink: 0 }} />
                <div style={{ fontSize: 13, color: 'var(--abi-text)', lineHeight: 1.65 }}>
                    <strong>Reporte de Pedidos:</strong> muestra una fila por cada producto dentro de cada pedido.
                    Selecciona un <strong>contrato</strong> para activar los demás filtros.
                    Puedes combinar estado, centro de costos, rango de fechas de entrega o creación, y número de pedido exacto.
                    El botón <strong>Excel</strong> exporta todos los resultados visibles con columnas limpias y anchos automáticos.
                </div>
            </div>

            {/* ── Panel de filtros ── */}
            <div className="order-section">
                <div className="order-section-header">
                    <i className="fa fa-sliders" /> Reporte de Pedidos
                </div>
                <div className="order-section-body">
                    <Row className="g-3 mb-2">
                        <Col md={5} xs={12}>
                            <Form.Label className="report-field-label">Contrato</Form.Label>
                            <SelectAgreement agreement={agreementFilter} setAgreement={setAgreementFilter} disabled={false} />
                        </Col>
                        <Col md={1} xs={6}>
                            <Form.Group>
                                <Form.Label className="report-field-label">Pedido #</Form.Label>
                                <Form.Control
                                    type="number" value={orderId}
                                    disabled={!agreementFilter}
                                    onChange={(e) => setOrderId(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={2} xs={6}>
                            <Form.Group>
                                <Form.Label className="report-field-label">Centro de Costo</Form.Label>
                                <Form.Select value={department} onChange={(e) => setDepartment(e.target.value)} disabled={!agreementFilter}>
                                    <option value={0}>Todos</option>
                                    {departments.map(d => (
                                        <option key={'dept' + d.id} value={d.id}>{d.id}: {d.name}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={2} xs={6}>
                            <Form.Group>
                                <Form.Label className="report-field-label">Estado</Form.Label>
                                <Form.Select value={status} onChange={(e) => setStatus(e.target.value)} disabled={!agreementFilter}>
                                    <option value={0}>Todos</option>
                                    {statuses.map(s => (
                                        <option key={'status' + s.id} value={s.id}>{s.id}: {s.description}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={2} xs={6} className="d-flex align-items-end pb-1">
                            {roles.includes('customer_order') && (
                                <Form.Check
                                    type="switch" id="only-my-orders"
                                    label="Solo mis pedidos"
                                    checked={onlyMyOrders}
                                    disabled={!agreementFilter}
                                    onChange={(e) => setOnlyMyOrders(e.target.checked)}
                                    style={{ fontSize: 13 }}
                                />
                            )}
                        </Col>
                    </Row>

                    <Row className="g-3 align-items-end">
                        <Col md={5} xs={12}>
                            <Form.Label className="report-field-label">
                                <i className="fa fa-truck" style={{ marginRight: 4 }} />
                                Fecha de entrega
                            </Form.Label>
                            <div className="report-date-range">
                                <Form.Control type="date" value={deliveryAtStart} disabled={!agreementFilter} onChange={(e) => setDeliveryAtStart(e.target.value)} />
                                <span className="report-date-sep">→</span>
                                <Form.Control type="date" value={deliveryAtEnd} disabled={!agreementFilter} onChange={(e) => setDeliveryAtEnd(e.target.value)} />
                            </div>
                        </Col>
                        <Col md={5} xs={12}>
                            <Form.Label className="report-field-label">
                                <i className="fa fa-calendar-plus-o" style={{ marginRight: 4 }} />
                                Fecha de creación
                            </Form.Label>
                            <div className="report-date-range">
                                <Form.Control type="date" value={createdAtStart} disabled={!agreementFilter} onChange={(e) => setCreatedAtStart(e.target.value)} />
                                <span className="report-date-sep">→</span>
                                <Form.Control type="date" value={createdAtEnd} disabled={!agreementFilter} onChange={(e) => setCreatedAtEnd(e.target.value)} />
                            </div>
                        </Col>
                        <Col md={2} xs={12} className="d-flex gap-2">
                            <Button variant="outline-secondary" onClick={clearFilters} title="Limpiar filtros" style={{ flex: 1 }}>
                                <i className="fa fa-times" /> Limpiar
                            </Button>
                            <Button variant="primary" onClick={getOrders} disabled={!agreementFilter} style={{ flex: 1 }}>
                                <i className="fa fa-filter" /> Filtrar
                            </Button>
                        </Col>
                    </Row>
                </div>
            </div>

            {message && <Alert variant={messageType || 'warning'} className="mt-2">{message}</Alert>}

            {orders.length > 0 && (
                <>
                    <div className="report-toolbar">
                        <span className="report-count">
                            <strong>{totalRows}</strong> líneas en <strong>{orders.length}</strong> pedido{orders.length !== 1 ? 's' : ''}
                        </span>
                        <div className="d-flex gap-2">
                            <Button variant="outline-success" size="sm" onClick={() => {
                                const headers = ['Pedido', 'Estado', 'C. Costos', 'Tipo producto', 'Producto', 'Ext ID', 'Precio unit.', 'Cantidad', 'IVA %', 'Total línea', 'Recibe', 'Teléfono', 'F. Entrega', 'H. Entrega', 'Evento', 'Dirección', 'Sector/Localidad', 'Notas', 'Fondo', 'F. Creación'];
                                const rows = orders.flatMap(o =>
                                    o.order_detail.map(d => [
                                        o.id,
                                        o.order_status?.description ?? '',
                                        `${o.fund?.department?.id}: ${o.fund?.department?.name}`,
                                        d.product?.product_type?.name ?? '',
                                        d.product?.name ?? '',
                                        d.product?.ext_id ?? '',
                                        parseFloat(d.price),
                                        d.quantity,
                                        parseFloat(d.taxes),
                                        parseFloat(d.total_amount),
                                        o.delivery_person_receiving ?? '',
                                        o.delivery_phone ?? '',
                                        o.delivery_date ?? '',
                                        o.delivery_time ?? '',
                                        o.delivery_event_name ?? '',
                                        o.delivery_address ?? '',
                                        o.sub_locality?.name ?? '',
                                        o.notes ?? '',
                                        `${o.fund_id}: ${o.fund?.ext_id}`,
                                        o.created_at ?? '',
                                    ])
                                );
                                downloadExcel(headers, rows, 'Reporte de pedidos', 'Pedidos');
                            }}>
                                <i className="fa fa-file-excel-o" /> Excel
                            </Button>
                            <Button variant="outline-primary" size="sm" title="Actualizar" onClick={getOrders}>
                                <i className="fa fa-rotate-right" />
                            </Button>
                        </div>
                    </div>

                    <Table responsive className="report-table no-print" id="orders">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Pedido</th>
                                <th>Estado</th>
                                <th>C. Costos</th>
                                <th className="d-none d-md-table-cell">Tipo</th>
                                <th>Producto</th>
                                <th>Precio sin IVA</th>
                                <th>Precio con IVA</th>
                                <th>Cant.</th>
                                <th className="d-none d-sm-table-cell">IVA</th>
                                <th>Total</th>
                                <th>Recibe</th>
                                <th>F. Entrega</th>
                                <th>H. Entrega</th>
                                <th className="d-none d-lg-table-cell">Evento</th>
                                <th className="d-none d-lg-table-cell">Dirección</th>
                                <th className="d-none d-xl-table-cell">Sector/Localidad</th>
                                <th className="d-none d-xl-table-cell">Notas</th>
                                <th>Fondo</th>
                                <th>F. Creación</th>
                                <th className="d-none d-xl-table-cell">F. Modificación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map(item => (
                                <React.Fragment key={'order-' + item.id}>
                                    {item.order_detail.map((detail, idx) => (
                                        <tr key={'det-' + detail.id}>
                                            {idx === 0 && (
                                                <td rowSpan={item.order_detail.length} className="report-action-cell">
                                                    <div className="report-action-cell-inner">
                                                        <button className="report-icon-btn" title="Ver pedido" onClick={() => navigate('/order/search/' + item.id)}>
                                                            <i className="fa fa-external-link" />
                                                        </button>
                                                        <button className="report-icon-btn" title="Ver log" onClick={() => { setShowLog(true); setIdOrderLog(item.id); }}>
                                                            <i className="fa fa-history" />
                                                        </button>
                                                        <button className="report-icon-btn" title="Imprimir" onClick={() => { setIdPrint(item.id); setShowPrint(true); }}>
                                                            <i className="fa fa-print" />
                                                        </button>
                                                    </div>
                                                </td>
                                            )}
                                            {idx === 0 && (
                                                <td rowSpan={item.order_detail.length} className="report-order-id">
                                                    #{item.id}
                                                </td>
                                            )}
                                            {idx === 0 && (
                                                <td rowSpan={item.order_detail.length}>
                                                    <StatusBadge status={item.order_status} />
                                                </td>
                                            )}
                                            {idx === 0 && (
                                                <td rowSpan={item.order_detail.length}>
                                                    {item.fund.department.id}: {item.fund.department.name}
                                                </td>
                                            )}
                                            <td className="d-none d-md-table-cell" style={{ fontSize: 11, color: 'var(--abi-muted)' }}>
                                                {detail.product.product_type.name}
                                            </td>
                                            <td>
                                                <div style={{ fontWeight: 600, fontSize: 13 }}>{detail.product.name}</div>
                                                <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>{detail.product.ext_id}</div>
                                            </td>
                                            <td>{currencyFormater(parseFloat(detail.price))}</td>
                                            <td>{currencyFormater(Math.round(parseFloat(detail.price) * ((parseFloat(detail.taxes) / 100) + 1)))}</td>
                                            <td className="text-center">{detail.quantity}</td>
                                            <td className="d-none d-sm-table-cell">{detail.taxes}%</td>
                                            <td><strong>{currencyFormater(detail.total_amount)}</strong></td>
                                            {idx === 0 && (
                                                <td rowSpan={item.order_detail.length} style={{ fontSize: 12 }}>
                                                    <div>{item.delivery_person_receiving}</div>
                                                    <div style={{ color: 'var(--abi-muted)' }}>{item.delivery_phone}</div>
                                                </td>
                                            )}
                                            {idx === 0 && <td rowSpan={item.order_detail.length} style={{ whiteSpace: 'nowrap' }}>{item.delivery_date}</td>}
                                            {idx === 0 && <td rowSpan={item.order_detail.length}>{item.delivery_time}</td>}
                                            {idx === 0 && <td rowSpan={item.order_detail.length} className="d-none d-lg-table-cell">{item.delivery_event_name}</td>}
                                            {idx === 0 && <td rowSpan={item.order_detail.length} className="d-none d-lg-table-cell" style={{ fontSize: 12 }}>{item.delivery_address}</td>}
                                            {idx === 0 && <td rowSpan={item.order_detail.length} className="d-none d-xl-table-cell" style={{ fontSize: 12 }}>{item.sub_locality?.name ?? ''}</td>}
                                            {idx === 0 && <td rowSpan={item.order_detail.length} className="d-none d-xl-table-cell" style={{ fontSize: 12 }}>{item.notes}</td>}
                                            {idx === 0 && <td rowSpan={item.order_detail.length} style={{ fontSize: 12 }}>{item.fund_id}: {item.fund.ext_id}</td>}
                                            {idx === 0 && <td rowSpan={item.order_detail.length} style={{ whiteSpace: 'nowrap', fontSize: 12 }}>{item.created_at}</td>}
                                            {idx === 0 && <td rowSpan={item.order_detail.length} className="d-none d-xl-table-cell" style={{ fontSize: 12 }}>{item.updated_at}</td>}
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>
                </>
            )}

            <Print show={showPrint} setShow={setShowPrint} idPrint={idPrint} setIdPrint={setIdPrint} />
            <Log show={showLog} setShow={setShowLog} orderId={idOrderLog} setOrderId={setIdOrderLog} />
        </>
    );
}

function mapStateToProps(state) {
    return { isLoading: state.isLoading, roles: state.roles };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(OrdersReport);
